module.exports = __webpack_public_path__ + "img/20200507_135654.4af209b2.jpg";